import { useMutation } from '@tanstack/react-query';
import { uploadFileApi } from 'api/fileUpload';

export default function useUploadFile() {
  return useMutation({ mutationFn: uploadFileApi });
}
